import { render, staticRenderFns } from "./safetyHealthyTargetMonthAppr.vue?vue&type=template&id=d60d01ba"
import script from "./safetyHealthyTargetMonthAppr.vue?vue&type=script&lang=js"
export * from "./safetyHealthyTargetMonthAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d60d01ba')) {
      api.createRecord('d60d01ba', component.options)
    } else {
      api.reload('d60d01ba', component.options)
    }
    module.hot.accept("./safetyHealthyTargetMonthAppr.vue?vue&type=template&id=d60d01ba", function () {
      api.rerender('d60d01ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/sai/sht/safetyHealthyTargetMonthAppr.vue"
export default component.exports